import { useTextTranslation } from "../../utils/useTextTranslation";
import React, { useContext } from "react";
import { SessionContext } from "../../context/SessionContext";
import localizationStrings from "../../statics/localization";
import { offerPrice, publicationEnd, rentalCopy } from "../../api/mw/rental";
import "./ConfirmPayment.scss";

const ConfirmPayment = ({
  vod,
  product,
  confirm,
  notConfirm,
  ppvProduct,
  program,
  pending = false,
  compact = false,
  acknowledged = false,
  onAcknowledgedChange = () => {}
}) => {
  const translateText = useTextTranslation();
  const { userFrameConfig } = useContext(SessionContext);
  const copy = rentalCopy();
  const needsConsent = product?.type === "RENTAL" && product.RequiresPublicationEndConfirmation === true;
  const end = publicationEnd(product);

  return (
    <div className="new-payment-container">
      {compact && product?.type === "RENTAL" ? (
        <>
          <dl className="rental-payment-summary">
            <div><dt>{copy.rentalFee}</dt><dd>{offerPrice(product)}</dd></div>
            <div><dt>{copy.viewingPeriod}</dt><dd>{product.duration} {copy.days}</dd></div>
          </dl>
          <p className="rental-payment-next">{copy.pinNext}</p>
        </>
      ) : <div className="new-payment-confirm-text">
        {product?.type === "RENTAL"
          ? localizationStrings.formatString(
            localizationStrings.payment.confirmText,
            {
              action: <span>{localizationStrings.payment.rent}</span>,
              day: (
                <span>
                  {` ${product?.duration} ${localizationStrings.days}`}
                </span>
              ),
              content: <span> {translateText(vod?.title)}</span>,
              price: <span>{offerPrice(product)}</span>
            }
          )
          : product?.type === "PURCHASE"
            ? localizationStrings.formatString(
              localizationStrings.payment.confirmTextBuy,
              {
                action: <span>{localizationStrings.payment.purchase}</span>,
                content: <span> {translateText(vod?.title)}</span>,
                price: <span>{`${product?.price} ${product?.currencySymbol || "₺"}`}</span>
              }
            )
            : product?.purchasetype == 2
              ? product?.bundle == 1
                ? localizationStrings.formatString(
                  localizationStrings.payment.confirmTextBundle,
                  {
                    action: <span>{localizationStrings.payment.rent}</span>,
                    day: (
                      <span>
                        {` ${product?.limittimes} ${localizationStrings.days}`}
                      </span>
                    ),
                    content: <span> {translateText(vod?.programname)}</span>,
                    price: (
                      <span>{`${product?.fee / parseInt(userFrameConfig?.Fee_Rate)
                        } ${product?.currencySymbol || "₺"}`}</span>
                    )
                  }
                )
                : product?.bundle == 2
                  ? localizationStrings.formatString(
                    localizationStrings.payment.confirmTextBuyBundle,
                    {
                      action: <span>{localizationStrings.payment.purchase}</span>,
                      content: <span> {translateText(vod?.programname)}</span>,
                      price: (
                        <span>{`${product?.fee / parseInt(userFrameConfig?.Fee_Rate)
                          } ${product?.currencySymbol || "₺"}`}</span>
                      )
                    }
                  )
                  : null
              : null}
      </div>}
      {needsConsent && <div className="rental-consent">
        <p role="note">{end ? `${copy.end} ${end}` : copy.invalidOffer}</p>
        {end && <label><input type="checkbox" checked={acknowledged} disabled={pending}
          onChange={(event) => onAcknowledgedChange(event.target.checked)} />{copy.consent}</label>}
      </div>}
      <div className="button-wrapper">
        <div className="confirm-button-box">
          <button
            className="not-confirm-button"
            disabled={pending}
            onClick={() => notConfirm()}
          >
            {localizationStrings.payment.cancel}
          </button>
          <button
            className="confirm-button"
            disabled={pending || (needsConsent && (!acknowledged || !end))}
            aria-busy={pending}
            onClick={() => confirm()}

          >
            {localizationStrings.payment.confirm}
          </button>
        </div>
      </div>
    </div>

  );
};

export default ConfirmPayment;
